import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface HeroSlide {
  id: string;
  title: string;
  subtitle: string | null;
  button_text: string;
  button_link: string;
  background_image_url: string;
  foreground_image_url: string | null;
  foreground_image_alt: string | null;
  display_order: number;
  active: boolean;
  created_at: string;
  updated_at: string;
}

export const useHeroSlides = () => {
  return useQuery({
    queryKey: ['hero-slides'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('hero_slides')
        .select('*')
        .eq('active', true)
        .order('display_order', { ascending: true });

      if (error) throw error;
      return data as HeroSlide[];
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
